import { QuantitySizeOptions } from '../item-product-cart/quantity-size-selector/quantity-size-selector.component';

import { CartItemStock, PendingCartItem } from '@api/cart/cart.models';
import { ShopCartCoreState } from '@shared/shopcart-core/store/shopcart-core.state';

/**
 * Modelo del State del shopcart actual
 */
export interface ShopCartState extends ShopCartCoreState {
    errors?: string[];
    itemsToShowDefault: number;
    showAllItems: boolean;
    showMoreMessage: boolean;
    moreMessage: string;
    moreItems: number;
    giftBoxes: Box[];
    stockItems?: Record<string, CartItemStock>;
    sizesItems?: Record<number, QuantitySizeOptions[]>;
    pendingCart: PendingCartItem[];
}

export interface Box {
    name: string;
    type: string;
    price: number;
    image: string;
    checked: boolean;
}

/**
 * Inicializa el State del shopcart actual vacío
 */
export const shopCartInitialState: ShopCartState = {
    itemsToShowDefault: 3,
    showAllItems: false,
    showMoreMessage: true,
    moreMessage: '',
    moreItems: null,
    giftBoxes: null,
    stockItems: null,
    sizesItems: null,
    pendingCart: [],
};
